import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import { Module } from 'vuex'
import JobState from './JobState'
import RootState from '../../RootState'

const jobModule: Module<JobState, RootState> = {
    namespaced: true,
    state: {
      cached: {},
      pending: {
        list: [],
        total: 0
      },
      running: {
        list: [],
        total: 0
      },
      history: {
        list: [],
        total: 0
      },
      miscellaneous: {
        list: [],
        total: 0
      },
      temporalExp: [],
      enumIds: {},
      current: {},
      pipelineFilters: {
        status: [],
        category: [],
        enum: [],
      },
      dataManagerLogs: []
    },
    getters,
    actions,
    mutations,
}

export default jobModule;

// TODO
// store.registerModule('job', jobModule);
